"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Expertise() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: copyRef,
    isVisible: copyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="18396" id="naše-odbornost-a-péče" className="bg-background text-foreground py-28 md:py-40 px-6 md:px-16">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {}
          <div ref={imageRef} data-index={0} className="lg:col-span-7 transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateY(0)" : "translateY(16px)"
        }}>
            <div className="overflow-hidden shadow-lg" style={{
            borderRadius: "0px"
          }}>
              <div className="relative w-full" style={{
              aspectRatio: "4 / 5"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/healing_hands_soul.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/healing_hands_soul.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/healing_hands_soul.webp-wvc-sizes" alt="Jemný dotek a duchovní léčení v bezpečném prostoru" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
              </div>
            </div>
          </div>

          {}
          <div ref={copyRef} data-index={1} className="lg:col-span-5 lg:pt-20 transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]" style={{
          opacity: copyVisible ? 1 : 0,
          transform: copyVisible ? "translateY(0)" : "translateY(16px)",
          transitionDelay: "120ms"
        }}>
            <h2 className="font-default font-normal text-foreground leading-[1.2]" style={{
            fontSize: "clamp(2rem, 4vw, 3.25rem)",
            letterSpacing: "-0.01em"
          }}>
              Cesta k <em className="font-serif italic text-primary">vnitřnímu</em> klidu a{" "}
              <em className="font-serif italic text-primary">uzdravení</em>
            </h2>

            <div className="mt-8 space-y-6 text-foreground/85">
              <p className="font-default leading-[1.6]" style={{
              fontSize: "clamp(1.0625rem, 1.2vw, 1.1875rem)"
            }}>
                V EPIONA propojujeme hlubokou psychologickou práci s duchovními principy. Pomáháme vám najít rovnováhu v každodenním shonu a provázíme vás procesem, který vede k opravdovému sebepřijetí a vnitřní svobodě.
              </p>
              <p className="font-default leading-[1.6]" style={{
              fontSize: "clamp(1.0625rem, 1.2vw, 1.1875rem)"
            }}>Každý krok naší spolupráce je veden s úctou k vaší jedinečné životní cestě. Vytváříme bezpečné prostředí, kde můžete odložit své masky a začít žít život v souladu se svou duší..</p>
            </div>

            
          </div>
        </div>
      </div>
    </section>;
}